import { useStaticQuery, graphql } from "gatsby"

const PREFIX = "stem-website"

const p = x => `${PREFIX}/${x}`

export function useCloudinaryImage(imageId) {
  const { allCloudinaryMedia } = useStaticQuery(graphql`
    query {
      allCloudinaryMedia {
        edges {
          node {
            secure_url
            public_id
          }
        }
      }
    }
  `)
  const nodes = allCloudinaryMedia.edges.map(edge => edge.node)
  if (typeof imageId === "string") {
    const image = nodes.find(node => node.public_id === p(imageId))
    if (!image) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(`Image ${p(imageId)} not found`)
      }
    }
    return image?.secure_url
  } else {
    if (process.env.NODE_ENV !== "production") {
      const missingImages = imageId.filter(
        imageId => !nodes.some(node => node.public_id === p(imageId))
      )
      if (missingImages.length > 0) {
        console.warn(
          `The following images were not found: ${missingImages
            .map(p)
            .join(", ")}`
        )
      }
    }
    return imageId.map(
      imageId => nodes.find(node => node.public_id === p(imageId))?.secure_url
    )
  }
}
